import { X, Check } from "lucide-react";
import { useLocation } from "@/lib/locations";

export const NotForEveryone = () => {
  const location = useLocation();
  return (
    <section className="py-24 bg-muted/20">
      <div className="container max-w-5xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">Who Uplevel Cleaning is NOT For</h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We're not the right fit for everyone. Here is who we are NOT a good match for:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-background p-8 rounded-2xl border shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-destructive/10 rounded-full">
                <X className="h-6 w-6 text-destructive" />
              </div>
              <h3 className="text-2xl font-bold">We Are NOT For You If...</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <X className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You are looking for the absolute cheapest cleaning option in {location.name} and don't care about quality or safety.</span>
              </li>
              <li className="flex gap-3">
                <X className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You want a cleaner who uses harsh, toxic chemicals instead of safe, eco-friendly products.</span>
              </li>
              <li className="flex gap-3">
                <X className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You don't care if the people in your home are background-checked, insured, or professionally trained.</span>
              </li>
              <li className="flex gap-3">
                <X className="h-5 w-5 text-destructive shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You want an unreliable service that shows up late or reschedules at the last minute.</span>
              </li>
            </ul>
          </div>

          <div className="bg-background p-8 rounded-2xl border shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="p-2 bg-primary/10 rounded-full">
                <Check className="h-6 w-6 text-primary" />
              </div>
              <h3 className="text-2xl font-bold">We ARE For You If...</h3>
            </div>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You value your time and want a reliable, professional team to handle the cleaning so you can focus on what matters.</span>
              </li>
              <li className="flex gap-3">
                <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You want peace of mind knowing that fully vetted, insured, and bonded professionals are in your home.</span>
              </li>
              <li className="flex gap-3">
                <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You appreciate a high-quality, consistent clean using safe and effective products.</span>
              </li>
              <li className="flex gap-3">
                <Check className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span className="text-muted-foreground">You want a seamless booking experience and excellent customer support from a local {location.name} business.</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
